import * as React from "react";
import Button from "@mui/material/Button";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Stack from "@mui/material/Stack";
import { useSelector } from "react-redux";
import { useOptionsDropDown } from "./hooks/useOptionsDropDown";

export default function OptionsDropDown({
  children,
  routesGroup = [],
  onChoose = () => {},
  midiaId,
  type = "icones",
  PermissionRouter,
  open,
  setOpen,
  size,
}) {
  const {
    InfoUsers,
    isMidiaActive,
    hasStroke,
    anchorRef,
    handleToggle,
    handleClose,
    handleListKeyDown,
  } = useOptionsDropDown(midiaId, open, setOpen);
  // const PermissionRouter = useSelector((state) => state.routergroups);

  // const InfoUsers = useSelector((state) => state.informationusers);
  // const [open, setOpen] = React.useState(false);
  // const anchorRef = React.useRef(null);

  // const hasStroke = [3, 9].includes(midiaId);

  // const isMidiaActive = React.useMemo(() => {
  //   const hasUserMidias =
  //     Boolean(InfoUsers) &&
  //     Boolean(InfoUsers.user_midias) &&
  //     Array.isArray(InfoUsers.user_midias);
  //   if (!hasUserMidias) return false;
  //   const isThisMidiaAllowed = InfoUsers.user_midias.some(
  //     (midia) => midia === midiaId
  //   );
  //   return isThisMidiaAllowed;
  // }, [InfoUsers]);

  // const handleToggle = () => {
  //   setOpen((prevOpen) => !prevOpen);
  // };

  // const handleClose = (event) => {
  //   if (anchorRef.current && anchorRef.current.contains(event.target)) {
  //     return;
  //   }

  //   setOpen(false);
  // };

  // function handleListKeyDown(event) {
  //   if (event.key === "Tab") {
  //     event.preventDefault();
  //     setOpen(false);
  //   } else if (event.key === "Escape") {
  //     setOpen(false);
  //   }
  // }

  // // return focus to the button when we transitioned from !open -> open
  // const prevOpen = React.useRef(open);
  // React.useEffect(() => {
  //   if (prevOpen.current === true && open === false) {
  //     anchorRef.current.focus();
  //   }

  //   prevOpen.current = open;
  // }, [open]);

  const topDistance = {
    small: "14px",
    regular: "18px",
  };

  return (
    <Stack direction="row" spacing={2} sx={{ height: "100%" }}>
      <div style={{ width: "100%" }}>
        <button
          disabled={
            midiaId === 1
              ? !InfoUsers.enablecallvoz
              : !(InfoUsers.enablecall && isMidiaActive)
          }
          className={`select-route-active-call-midia__btn ${
            hasStroke ? "stroke" : ""
          } fill ${open ? "opened" : ""}`}
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: type === "list" ? "center" : "center",
            paddingRight: "4px",
            paddingLeft: "4px",
          }}
          ref={anchorRef}
          id="composition-button"
          aria-controls={open ? "composition-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          onClick={(e) => {
            const hasRoutes = routesGroup.length > 0;
            if (!hasRoutes) {
              onChoose(e, PermissionRouter);
              return;
            }
            // const hasOnlyOneRoute = routesGroup.length === 1;
            // if (hasOnlyOneRoute) {
            //   onChoose(e, [routesGroup[0]]);
            //   return;
            // }
            handleToggle();
          }}
        >
          {children}
          {/* {Boolean(numberOfRoutes) && (
            <span
              className={`select-route-active-call-midia__btn__number-of-routes ${
                type === "list" ? "list-type-of-number-of-routes" : ""
              }`}
            >
              {numberOfRoutes}
            </span>
          )} */}
        </button>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="bottom"
          transition
          disablePortal
          style={{ zIndex: 1 }}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom-start" ? "left top" : "left bottom",
              }}
            >
              <Paper sx={{ backgroundColor: "transparent", boxShadow: "none" }}>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="composition-menu"
                    aria-labelledby="composition-button"
                    onKeyDown={handleListKeyDown}
                    className="select-route-active-call-midia__render-options"
                    sx={{ padding: "0px", backgroundColor: "#FFFFFF" }}
                  >
                    {routesGroup.map((routeInfo, index) => {
                      return (
                        <MenuItem
                          key={`options-drop-down--${index}`}
                          onClick={(e) => {
                            onChoose(e, [routeInfo]);
                            handleClose(e);
                          }}
                        >
                          {routeInfo.desctrunk}
                          {routeInfo.isdefault === "t" && (
                            <span className="select-route-active-call-midia__render-options__default-label">
                              Padrão
                            </span>
                          )}
                        </MenuItem>
                      );
                    })}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </Stack>
  );
}
